// extracted by mini-css-extract-plugin
module.exports = {"toggleInput":"ToggleInput_toggleInput__SMFCV","toggle":"ToggleInput_toggle__MpcLN","content":"ToggleInput_content__9rPuT"};